import React from 'react';
import PropTypes from 'prop-types';
import { Message } from '@bwoty-web/ui-kit';

import './validationContainer.scss';

const getPriceOfferNumber = (id) => {
  return parseInt(id, 10) + 1;
};

const ValidationContainer = ({ validations, priceOfferId }) => {
  ValidationContainer.propTypes = {
    validations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    priceOfferId: PropTypes.number.isRequired,
  };

  return (
    <div className="price-offer-validation-container">
      <div className="price-offer-validation--title">
        {`Validation page for price offer id ${priceOfferId}`}
      </div>
      {validations.map((validation) => {
        return (
          <div className="price-offer-validation">
            {validation.propertyValidations.map((property) => {
              const { validationType, propertyPath, message, contentCode, contentUrl } = property;
              switch (validationType) {
                case 'dataValidation':
                  return (
                    <Message
                      messageType="error"
                      header="Package missing"
                      isInitiallyExpanded
                    >
                      <div className="price-offer-validation--property">
                        <span className="price-offer-validation--property-title">
                          {message}
                        </span>
                      </div>
                    </Message>
                  );
                case 'contentValidation':
                default:
                  return (
                    <Message
                      messageType="error"
                      header={`Package number ${getPriceOfferNumber(validation.id)}`}
                      isInitiallyExpanded
                      link={contentUrl}
                      linkText="ContentUrl"
                    >
                      <div className="price-offer-validation--property">
                        <span className="price-offer-validation--property-title">
                          {message}
                        </span>
                        <span>
                          {contentCode ? `ContentCode: ${contentCode}` : null}
                        </span>
                        <span>
                          {propertyPath ? `PropertyPath: ${propertyPath}` : null}
                        </span>
                      </div>
                    </Message>
                  );
              }
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ValidationContainer;
